import React from 'react';
import { connect } from "react-redux";
import createPosProstor from './../../../API/Admin/CreatePosProstor'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../Global/loader'

class CreatePosProstor extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        label: "",
        address: "",
        description: "",
        premises_name: "",
        ecommerce: false,
        loading: false
    }

    
    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    submitCreate = async (e) => {
        this.setState({ loading: true })
        e.preventDefault()        
        let createPP = await createPosProstor(this.props.oneClientInfo.uuid, this.state.label, this.state.address, this.state.description, this.state.premises_name, this.state.ecommerce)
        if(createPP.data.uuid){ 
            store.addNotification({
                title: "Uspješno!",
                message: "Kreiranje poslovnog korisnika " + this.state.label + " je završeno",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom kreiranja Poslovnog Prostora, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
    }

    handleEcommerce = async () => {
        this.setState({
            ecommerce: !this.state.ecommerce
        })
    } 
   
    render(){  
        return (
            <>
                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="label" className="col-sm-4 col-form-label">Oznaka</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="label"                          
                                            type="text"
                                            value={this.state.label}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="address" className="col-sm-4 col-form-label">Adresa</label>
                                <div className="col-sm-8">
                                    <input
                                        id="address"  
                                        type="text"
                                        value={this.state.address}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="description" className="col-sm-4 col-form-label">Opis</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="description"                         
                                        type="text"
                                        value={this.state.description}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="premises_name" className="col-sm-4 col-form-label">Naziv prostora</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="premises_name"                         
                                        type="text"
                                        value={this.state.premises_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>   
                            <div className="form-group row" style={{ alignItems: 'center' }}>
                                <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                                <div className="col-sm-8">
                                    <label className="form-check-label" htmlFor="ecommerce">
                                        <input      
                                            id="ecommerce"                                          
                                            type="checkbox"
                                            checked={this.state.ecommerce}
                                            onChange={e => this.handleEcommerce(e)}
                                        />
                                        &nbsp;&nbsp; e-commerce
                                    </label>
                                </div>
                            </div>

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                      
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>
                </form>
                }
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreatePosProstor);


